export default [
  {
    path: '/objects',
    name: 'objects',
    component: () => import('@/views/Objects/Objects.vue'),
    meta: {
      pageTitle: 'List All Object',
      breadcrumb: [
        {
          text: 'Object',
          active: true,
        },
      ],
    },
  },
  {
    path: '/objects/addObject',
    name: 'addObject',
    component: () => import('@/views/Objects/AddObject/AddObject.vue'),
    meta: {
      pageTitle: 'Add Object',
      breadcrumb: [
        {
          text: 'Add Object',
          active: true,
        },
      ],
    },
  },
  {
    path: '/object/:id',
    component: () => import('@/views/Objects/Object/Object.vue'),
    name: 'object',
    meta: {
      pageTitle: 'Object',
      breadcrumb: [
        {
          text: 'Object',
          active: true,
        },
      ],
    },
  },
]
